/* AELA (26 Oct 2026, part 2) */

/* Product names: style name on line one (Tenor Sans), format underneath in small capitals.
   "Soft Kiss · 48-Cluster Set" shows as SOFT KISS / 48 PRE-BONDED CLUSTERS. Product titles in Shopify stay unchanged
   (Google, Instagram Shop and Meta read those). Card taglines show their first line only. */
(function () {
  function fmt(sub) {
    var m = sub.match(/^(\d+)-Cluster Set$/i);
    if (m) return m[1] + ' Pre-bonded Clusters';
    if (/^Pre-mapped 3-Pack$/i.test(sub)) return '3 Pre-mapped Pairs';
    return sub;
  }
  function split(el) {
    if (el.dataset.aelaSplit) return;
    var t = el.textContent.trim();
    var i = t.indexOf(' · ');
    el.dataset.aelaSplit = '1';
    if (i < 0) return;
    el.textContent = t.slice(0, i);
    var s = document.createElement('span');
    s.className = 'aela-fmt';
    s.textContent = fmt(t.slice(i + 3));
    el.appendChild(s);
  }
  function run() {
    document.querySelectorAll('.product-card .product-title').forEach(split);
    document.querySelectorAll('.product-card .aela-card-tag').forEach(function (p) {
      if (p.dataset.aelaShort) return;
      p.dataset.aelaShort = '1';
      var m = p.textContent.trim().match(/^[^.,]+/);
      if (m) p.textContent = m[0] + '.';
    });
    var h = document.querySelector('.product-info h1');
    if (h && !h.classList.contains('aela-ptitle')) { h.classList.add('aela-ptitle'); split(h); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function () { clearTimeout(window.__aelaNameT); window.__aelaNameT = setTimeout(run, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* Lash sets and pre-mapped packs have no Colour option in Shopify yet. Show Colour: Black with Brown, Coming soon,
   in the same style as the kits. Display only: nothing changes on the product, the live store is unaffected. */
(function () {
  var path = location.pathname;
  if (!/\/products\/[^/]*(cluster-set|premapped|pre-mapped)/.test(path)) return;
  function addColour() {
    var list = document.querySelector('.product-info__block-list');
    if (!list || list.querySelector('.aela-colour-row')) return;
    var hasColour = [].some.call(list.querySelectorAll('variant-picker .variant-picker__option legend'), function (l) { return /colou?r/i.test(l.textContent); });
    if (hasColour) return;
    var qty = list.querySelector('quantity-selector');
    var anchor = qty ? qty.closest('.product-info__block-item') : list.querySelector('buy-buttons, .product-info__block-item:has(form)');
    if (!anchor) return;
    var row = document.createElement('div');
    row.className = 'product-info__block-item aela-colour-row';
    row.innerHTML = '<div class="variant-picker__option v-stack gap-2">' +
      '<div class="variant-picker__option-info h-stack gap-1"><span class="aela-colour-row__legend">Colour:</span><span>Black</span></div>' +
      '<div class="variant-picker__option-values h-stack gap-2.5 wrap">' +
      '<span class="color-swatch aela-colour-row__on" title="Black" style="--swatch-background: linear-gradient(to right, black, black)"><span class="sr-only">Black</span></span>' +
      '<span class="aela-brown-soon" title="Brown, coming soon"><span class="color-swatch aela-brown-soon__swatch" aria-hidden="true" style="--swatch-background: linear-gradient(to right, #5b4033, #5b4033)"></span>' +
      '<span class="aela-brown-soon__text">Brown <span class="aela-soon">Coming soon</span></span></span>' +
      '</div></div>';
    anchor.parentNode.insertBefore(row, anchor);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addColour); else addColour();
})();

/* Build your box tiles show the product's second photo on hover.
   Reads the photos from the same collections the builder uses, so new products pick it up automatically. */
(function () {
  var root = document.querySelector('.aela-rb');
  if (!root) return;
  var cols = ['48-cluster-sets', '72-cluster-sets', 'pre-mapped-3-packs'];
  var map = {};
  Promise.all(cols.map(function (c) {
    return fetch('/collections/' + c + '/products.json?limit=50').then(function (r) { return r.json(); }).then(function (d) {
      (d.products || []).forEach(function (p) {
        if (!p.images || p.images.length < 2) return;
        p.variants.forEach(function (v) { map[v.id] = p.images[1].src; });
      });
    }).catch(function () {});
  })).then(function () {
    root.querySelectorAll('.aela-rb__tile').forEach(function (t) {
      var src = map[t.getAttribute('data-id')];
      var box = t.querySelector('.aela-rb__img');
      if (!src || !box || box.querySelector('.aela-rb__img2')) return;
      var img = document.createElement('img');
      img.className = 'aela-rb__img2';
      img.loading = 'lazy';
      img.alt = '';
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=500';
      box.insertBefore(img, box.firstChild.nextSibling);
    });
  });
})();
